<template>
  <transition name="modal" appear>
    <div class="modal-overlay" @click="$emit('close')">
      <section class="modal-dialog wrap_iframe">
        <button class="btn_modal_close icon_btn"></button>
        <iframe ref="iframe" :src="('/static/public/terms/' + src)"></iframe>
      </section>
    </div>
  </transition>
</template>

<script>
export default {
  props: ["src"],
  mounted() {
      this.$refs.iframe.focus();
  }
};
</script>
<style scoped>
.modal-overlay {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  z-index: 10000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
}

.modal-dialog {
  width: 90%;
  border-radius: 4px;
  background: #fff;
}
</style>
